import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { onUserAuth } from '../store/reducers/routePlannerUser';
import {
  getCurrentUser,
  getLoginUser,
  getUserError,
  getUserLoading,
} from '../store/selectors/user';
import Loader from '../components/Loader';
import SomethingWentWrong from '../components/SomethingWentWrong';

const useUserAuth = () => {
  const loginUser = useSelector(getLoginUser);
  const plannerUser = useSelector(getCurrentUser);
  const userError = useSelector(getUserError);
  const userLoading = useSelector(getUserLoading);
  const dispatch = useDispatch();

  const userId = useMemo(() => loginUser?.id, [loginUser]);

  useEffect(() => {
    if (userId) {
      dispatch(onUserAuth(loginUser));
    }
  }, [userId, dispatch, loginUser]);

  return {
    userId: plannerUser?.uid,
    userError,
    userLoading,
  };
};

const UserProvider = () => {
  const { userId, userError, userLoading } = useUserAuth();

  return useMemo(() => {
    if (userLoading || !userId) {
      return <Loader />;
    }

    if (userError) {
      const errorType =
        userError === 'Cannot find user' ? 'UNAUTHORIZED' : 'default';

      return <SomethingWentWrong errorType={errorType.toUpperCase()} />;
    }

    return <Outlet />;
  }, [userId, userLoading, userError]);
};

export default UserProvider;
